import React from 'react';
import { Menu, X } from 'lucide-react';
import { HeaderProps, NavItem } from '../types';

const Header: React.FC<HeaderProps> = ({ isMobileMenuOpen, toggleMobileMenu }) => {
  const navItems: NavItem[] = [
    { href: '#about', label: 'About' },
    { href: '#experience', label: 'Experience' },
    { href: '#skills', label: 'Skills' },
    { href: '#contact', label: 'Contact' }
  ];

  return (
    <header className="bg-white/70 backdrop-blur-lg sticky top-0 z-50 border-b border-gray-200/50">
      <nav className="container mx-auto px-6 py-5 flex justify-between items-center">
        <button 
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="text-xl font-semibold tracking-wider bg-transparent border-none cursor-pointer hover:text-slate-600 transition-colors"
        >
          Sveva Falanga
        </button>
        
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-10">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`nav-link text-sm font-medium text-slate-700 hover:text-slate-900 ${
                item.label === 'Contact' 
                  ? 'bg-slate-800 text-white font-medium py-2 px-5 rounded-full hover:bg-slate-700 transition duration-300' 
                  : ''
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>
        
        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button 
            onClick={toggleMobileMenu}
            className="text-slate-800 focus:outline-none"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </nav>
      
      {/* Mobile Menu */}
      <div className={`md:hidden bg-white transition-all duration-300 ${
        isMobileMenuOpen ? 'block' : 'hidden'
      }`}>
        {navItems.map((item) => (
          <a
            key={item.href}
            href={item.href}
            className="block py-2.5 px-6 text-sm text-slate-700 hover:bg-gray-50"
            onClick={() => toggleMobileMenu()}
          >
            {item.label}
          </a>
        ))}
      </div>
    </header>
  );
};

export default Header; 